import { Icon, Msg } from "@shared/components";

export const FaceVerificationStep = () => {
  const classNamePrefix = "code-editor-exam-detail__face-verification";

  return (
    <div className={classNamePrefix}>
      <div>
        <Msg id="editor-exam-detail.modals.thirdModal.text" />
      </div>
      <div className={`${classNamePrefix}__icon-container`}>
        <div
          className={`${classNamePrefix}__icon-container__icon ${classNamePrefix}__icon-container__icon--good`}
        >
          <span
            className={`${classNamePrefix}__icon-container__icon__banner ${classNamePrefix}__icon-container__icon__banner--green`}
          >
            <Msg id="editor-exam-detail.modals.fourthModal.good-icon-text" />
          </span>
        </div>
        <div
          className={`${classNamePrefix}__icon-container__icon ${classNamePrefix}__icon-container__icon--bad`}
        >
          <span
            className={`${classNamePrefix}__icon-container__icon__banner ${classNamePrefix}__icon-container__icon__banner--red`}
          >
            <Msg id="editor-exam-detail.modals.fourthModal.bad-icon-text" />
          </span>
        </div>
      </div>
      <div className={`${classNamePrefix}__list`}>
        <ol>
          <li>
            <Msg id="editor-exam-detail.modals.thirdModal.point0" />
          </li>
          <li>
            <Msg id="editor-exam-detail.modals.thirdModal.point1" />
          </li>
          <li>
            <Msg id="editor-exam-detail.modals.thirdModal.point2" />
          </li>
          <li>
            <Msg id="editor-exam-detail.modals.thirdModal.point3" />
          </li>
        </ol>
      </div>
      <div className={`${classNamePrefix}__warning-container`}>
        <Icon
          type={"circle-exclamation"}
          iconClassName={`${classNamePrefix}__warning-container__icon`}
        />
        <div>
          <div>
            <Msg
              id="editor-exam-detail.modals.thirdModal.warning-title"
              className={`${classNamePrefix}__warning-container__title`}
            />
          </div>
          <div>
            <Msg
              id="editor-exam-detail.modals.thirdModal.warning-text"
              className={`${classNamePrefix}__warning-container__text`}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
